var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconMarketTrends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-trending-features-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,1a3,3,0,0,0-1.91,5.31L16,12h0a3,3,0,0,0-2.08.84L11,11.37A2.22,2.22,0,0,0,11,11a3,3,0,0,0-6,0,3,3,0,0,0,.94,2.17L4.23,17A.86.86,0,0,0,4,17a3,3,0,1,0,3,3,3,3,0,0,0-.94-2.17L7.77,14A.86.86,0,0,0,8,14a3,3,0,0,0,2.08-.84L13,14.63A2.22,2.22,0,0,0,13,15a3,3,0,1,0,4.91-2.31L20,7h0a3,3,0,0,0,0-6ZM4.91,20.41A1,1,0,0,1,3,20a1,1,0,0,1,.09-.41,1,1,0,0,1,1.83.79A0,0,0,0,1,4.91,20.41ZM9,11a1,1,0,1,1-.61-.92,1.4,1.4,0,0,1,.17.09A1,1,0,0,1,9,11Zm7.92,4.39a1,1,0,0,1-1.31.53l-.13-.07A1,1,0,0,1,15,15a1,1,0,1,1,1.92.39ZM20,5a1,1,0,0,1-1-1,1,1,0,0,1,.06-.34A1,1,0,0,1,21,4a1,1,0,0,1-.06.34l0,0A1,1,0,0,1,20,5Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconMarketTrends);
export default __webpack_public_path__ + "static/media/navigation-icon-market-trends.90b5c5e4f8f895b08279bd853391360d.svg";
export { ForwardRef as ReactComponent };